export default __webpack_public_path__ + "static/media/emptyTeacher.c1915c86.jpg";